<template>
  	<div class="" id="app">
      <div :style="style">
        <view-header></view-header>
        <router-view></router-view>
        <viewFoot></viewFoot>
        <viewAside class="rightB"></viewAside>

      </div>
      
  	</div>
</template>

<script>
import viewHeader from './components/header.vue'
import viewFoot from './components/footer.vue'
import viewAside from './components/aside.vue'


export default {
  	name: 'App', 
    components:{
      viewHeader,viewFoot,viewAside
    }, 
  data(){
    return{
			style:{},
      
    }
   
  },
  created() {
		// let _self = this;
		// console.log(window.screen.availWidth,'window.innerWidth');
		// if (window.screen.availWidth < 1440) {
		// 	let num = window.screen.availWidth / 1440;
		// 	_self.style = {
		// 		width: '1440px',
		// 		position: 'absolute',
		// 		top:'0',
		// 		left:'50%',
		// 		transformOrigin:'top left',
		// 		transform: 'scale(' + num + ') translate(-50%,0)'
		// 	}
		// }
	},
  mounted() {
    // document.dispatchEvent(new Event('render-event'))
  },

  methods: {
    updateElementStyle() {
      const availWidth = window.screen.availWidth;
      const innerWidth = window.innerWidth;
      console.log(availWidth, innerWidth);

      if (availWidth < 1440) {
        let num = availWidth / 1440;
        this.elementStyle = {
          width: '1440px',
          position: 'absolute',
          top: '0',
          left: '50%',
          transformOrigin: 'top left',
          transform: `scale(${num}) translate(-50%, 0)`
        };
      } else {
        this.elementStyle = {
          width: '100%',
          position: 'relative',
          transform: 'none',
          left: '0',
          top: '0'
        };
      }
    }
  },

}
</script>

<style>
   /* ::-webkit-scrollbar {
     width: 0 !important;
   }
   ::-webkit-scrollbar {
     width: 0 !important;height: 0;
   } 
  overflow-x:hidden; 隐藏横的
     
   
   
   */



body{
	margin: 0;
  color: #191919;
  background: #F9F9F9;
  overflow-x:hidden; 
  font-size: 16px;
}
@media screen and (max-width: 1440px) {
	html,
	body {
		width: 100%;
	}
	#app{
		position: relative;
		width: 1440px;
	}
}
#app {
	width: 100vw;
	height: 100vh;
}
.ls-flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.ls-flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.ls-flex-col-center{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.mauto{
  margin: auto;
}

.fs-14{
  font-size: 0.875rem !important;
}
.fs-16{
  font-size: 1rem !important;
}
.fs-18{
  font-size: 1.125rem !important;
}
.fs-20{
  font-size: 1.25rem !important;
}
.fs-22{
  font-size: 1.375rem !important;
}
.font-bold{
  font-weight: bold;
}
.color-white{
  color: #fff !important;
}
.color1{
  color: #0D7BE6 !important;
}
.color6{
  color: #666666;
}
.color9{
  color: #999999;
}
.bg-white{
  background: #fff;
}
.bg1{
  background: #0D7BE6;
}
.pointer{
  cursor: pointer;
}
.b-m-1{
  border: 1px solid #0D7BE6;
}
.b-b-1{
  border-bottom: 1px solid rgba(153,153,153,0.2);
}
.b-b-a-1{
  border-bottom: 1px solid #0D7BE6;
}
.nowrap1 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.nowrap2 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.nowrap3 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.max-width{
  width: 1400px;
  @media screen and (max-width: 1400px) {
    /* padding-left: 30px;
    padding-right: 30px; */
  }
}

</style>
